"use client";

import { c as _c } from "react/compiler-runtime";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
interface DevActivityBarChartProps {
  data: {
    name: string;
    slug: string;
    commits: number;
    prs: number;
    devs: number;
    score: number;
    imageUrl?: string | null;
  }[];
}
export function DevActivityBarChart(t0) {
  const $ = _c(12);
  const {
    data
  } = t0;
  if (!data.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: 10,
      right: 10,
      left: 0,
      bottom: 40
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fill: "#9ca3af",
      fontSize: 11
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <XAxis dataKey="name" tick={t3} angle={-35} textAnchor="end" height={60} axisLine={{
      stroke: "rgba(255,255,255,0.08)"
    }} tickLine={false} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <YAxis tick={{
      fill: "#9ca3af",
      fontSize: 11
    }} axisLine={false} tickLine={false} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Tooltip contentStyle={{
      backgroundColor: "hsl(230, 15%, 10%)",
      border: "1px solid hsl(230, 15%, 20%)",
      borderRadius: "12px",
      padding: "12px 16px",
      color: "#fff",
      fontSize: "13px"
    }} labelStyle={{
      color: "#9ca3af",
      marginBottom: 4
    }} cursor={{
      fill: "rgba(255,255,255,0.03)"
    }} />;
    t7 = <Legend verticalAlign="top" height={30} iconSize={10} iconType="rect" formatter={_temp} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Bar dataKey="commits" name="Commits" fill="#3b82f6" radius={[4, 4, 0, 0]} />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Bar dataKey="prs" name="PRs Merged" fill="#06b6d4" radius={[4, 4, 0, 0]} />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Bar dataKey="devs" name="Active Devs" fill="#8b5cf6" radius={[4, 4, 0, 0]} />;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== data) {
    t11 = <div className="w-full h-[400px]"><ResponsiveContainer width="100%" height="100%"><BarChart data={data} margin={t1} barCategoryGap="20%" barGap={2}>{t2}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</BarChart></ResponsiveContainer></div>;
    $[10] = data;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}
function _temp(value) {
  return <span className="text-xs text-gray-400">{value}</span>;
}